// new API
export { LOGIN_STATE } from './constants';
export { XingFrameProvider, XingFrameConsumer } from './XingFrameProvider';
export { default as xingConnect } from './xingConnect';
